export default "__VITE_ASSET__CbG$IgKR__"